export type DocumentKey = string;

export interface LocalDocument {
  id: string;
  type: string; // 013-019 etc.
  label: string;
  asset_file_path?: string; // backend path/nombre
  file_name?: string; // nombre mostrado
  file?: File; // pending upload
  isPending?: boolean; // no subido aún
  isDeleted?: boolean; // marcado para borrar
  order: number; // orden de inserción estable
}

/**
 * Genera una clave única basada en id o asset_file_path/file_name.
 */
export const getDocumentKey = (doc: Partial<LocalDocument>): DocumentKey | null => {
  if (doc.id) return doc.id;
  if (doc.asset_file_path) return doc.asset_file_path;
  if (doc.file_name) return doc.file_name;
  return null;
};

/**
 * Normaliza un filename para comparar cuando el backend renombra (quita path y deja base).
 */
export const normalizeFilename = (name: string): string => {
  const base = name.split('/').pop() || name;
  return base.toLowerCase();
};

